import { Col, Container, Image, Row, Tab, Tabs, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Desplegable from "../desplegable";
import { FormOrganizacion } from "./formOrganizacion";
import ListaExternos from "./externos/ListaExternos";
import ListaMisionLocalHermanas from "./externos/ListaMisionLocalHermanas";

// Banner de la organizacion(actualmente el nombre y el logo de STJ)
export const Banner = ({ name, logo }) => {
    return (
        <Row bg="light" className="shadow-lg mx-3 my-5 align-items-center p-1">
            <Col className="d-flex justify-content-center" xs={12} sm={12} lg={6}>
                <Image
                    className="img-fluid-detalle"
                    variant="top"
                    src={logo ? "/images/" + logo : "/images/logoSTJ.png"}
                    alt="organizationImg"
                    height='100%'
                />
            </Col>
            <Col xs={12} sm={12} lg={6} className="text-center">
                <h5 className="detail-title-sister">{name}</h5>
            </Col>
        </Row>
    )
}

// Contenido de cada pestana dentro del componente organizacion(incluye a los desplegables)
const TabContent = ({ fields, cargos, disponibles, post, getExtern, colegioseleccionado, refresca }) => {
    // Cada tabContent tiene su propio modalArray
    const [modalArray, setModalArray] = useState([]);
    useEffect(() => {
        setModalArray(fields.map(() => false));
    }, [fields]);

    const handleButtonShow = (event) => {
        let aux = [...modalArray];
        if (event) {
            aux[event.target.id] = !aux[event.target.id];
        }

        if (event === undefined || event.target.name === "Cerrar") {
            for (let i = 0; i < aux.length; i++) {
                aux = aux.map(() => false);
            }
        }
        setModalArray(aux);
    }

    //contenido de las pestañas recibe los parametros arriba indicados además del coleseleccionado para llevarlo de la mano hasta el form final. esto tb habrá que hacerlo en paises
    return (
        <>
            {
                //colegioseleccionado  && colegioseleccionado.valor + ' seleccion de cole'
            }
            {fields.map((item, idx) =>

                <Desplegable
                    eventKey={idx}
                    id={idx}
                    Toogle={item.name}
                    canEdit={true}
                    showModal={modalArray[idx]}
                    handleButtonShow={handleButtonShow}

                    Form={<FormOrganizacion field={item} disponibles={{
                        cargosHer: disponibles.cargosHer.filter(c => c.name === item.name).map(c => c.charge),
                        cargosExt: disponibles.cargosExt.filter(c => c.name === item.name).map(c => c.charge)
                    }}
                        getExtern={getExtern}
                        cargosOcupados={cargos.filter(c => c.front.name === item.name)}
                        handleButtonShow={handleButtonShow}
                        //campo jose para el cole si es este 
                        coleSeleccionado={colegioseleccionado}
                        //función para refrescar tras guardar
                        refresca2={refresca}
                        post={post} />}

                    Text={
                        <Container className="mb-3">
                            {item.charges.map(charge =>
                                <Row>
                                    <Col lg="12" className="border">
                                        <header className="input-group-text mt-1"><strong>{charge}</strong></header>

                                        <p className="mt-2">{extraerNombreDeCargo(item.name, charge, cargos)}</p>
                                    </Col>
                                </Row>
                            )}
                        </Container>
                    }
                />
            )}
        </>
    )
}

//////////////////////////////////
//// FUNCIONES UTILES ///////////
////////////////////////////////
const cargarListaCargos = (field_name, charge, cargos) => {
    return cargos.filter(c => c.front.name === field_name && c.front.charge === charge);
}

const extraerNombreDeCargo = (field_name, charge, cargos) => {
    return cargarListaCargos(field_name, charge, cargos).map(c =>
        <p>

            {c.sister?.user ?
                `${c.sister.user.name} ${c.sister.user.firstSurname} ${c.sister.user.secondSurname} desde ${c.startDate ? c.startDate : `"No asignada"`} hasta ${c.endDate
                    ?
                    `${c.endDate}` : `la actualidad`}`
                :
                c.externo?.name ?
                    `${c.externo.name} ${c.externo.firstSurname} ${c.externo.secondSurname} desde ${c.startDate ? c.startDate : `"No asignada"`} hasta ${c.endDate
                        ?
                        `${c.endDate}` : `la actualidad`}` : 'ERROR'}
        </p>);
}
////////////////////////////////

// Componente "generico" de una organizacion de la familia teresiana(FET, FUNDEO, MTA). Los datos se extraen de la configuracion que se pasa como prop
// vease los componentes fet, mta y fundeo en esta misma carpeta
const Organizacion = ({ config, ErrorHandling }) => {
    const [cargos, setCargos] = useState([]);
    const [disponibles, setDisponibles] = useState({ cargosHer: [], cargosExt: [] });
    const [refresh, setRefresh] = useState(false);

    //hooks jose formulario coles
    const [colegios, setColegios] = useState([]);
    const [cole, setCole] = useState({});
    const [disponiblesCole, setDisponiblesCole] = useState({ cargosHer: [], cargosExt: [] });
    const [cargosCole, setCargosCole] = useState([]);
    const [refreshCole, setRefreshCole] = useState(false);

    //hooks jose formulario paises
    const [paises, setPaises] = useState([]);
    const [pais, setPais] = useState({});
    const [disponiblesPais, setDisponiblesPais] = useState({ cargosHer: [], cargosExt: [] });
    const [cargosPais, setCargosPais] = useState([]);
    const [refreshPais, setRefreshPais] = useState(false);

    // Fetch de los cargos y se incluyen cargos de coles y paises
    useEffect(() => {
        const fn = async () => {
            //obtengo cargos de la FET
            const promiseCargos = config.fetchCargos(ErrorHandling)
            setCargos(await promiseCargos);
            //obtengo cargos disponibles de la FET
            const promiseDisponibles = config.fetchDisponibles(ErrorHandling)
            setDisponibles(await promiseDisponibles);

            //coles y paises
            switch (config.extra) {
                case 'coles':
                    //obtengo coles
                    const promiseColegios = config.fetchColegios(ErrorHandling)
                    setColegios(await promiseColegios)
                    //obtengo cargos disponibles en coles
                    const promiseDisponiblesCole = config.fetchDisponiblesColegio(ErrorHandling)
                    setDisponiblesCole(await promiseDisponiblesCole);
                    break
                case 'paises':
                    //obtengo paises
                    const promisePaises = config.fetchPaises(ErrorHandling)
                    setPaises(await promisePaises)
                    //obtengo cargos disponibles en paises
                    const promiseDisponiblesPais = config.fetchDisponiblesPaises(ErrorHandling)
                    setDisponiblesPais(await promiseDisponiblesPais);
                    break
                default:
            }

        };
        fn();
    }, [config, refresh])

    //COLES funcion para controlar el pique en el select de coles
    const hePicadoCole = async (e) => {
        setCole({ valor: e.target.value, nombre: e.target.options[e.target.selectedIndex].innerHTML })
        //leo los cargos del cole seleccionado
        const promiseCargosSchoolDisponibles = config.fetchCargosSchool(e.target.value, ErrorHandling)
        setCargosCole(await promiseCargosSchoolDisponibles)
    }
    //funcion para refrescar con el id del cole desde otros componentes
    const refrescaColesDesdeOtros = async () => {
        //leo los cargos del cole seleccionado
        const promiseCargosSchoolDisponibles = config.fetchCargosSchool(cole.valor, ErrorHandling)
        setCargosCole([])
        setCargosCole(await promiseCargosSchoolDisponibles)
    }
    //PAISES funcion para controlar el pique en el select de coles
    const hePicadoPais = async (e) => {
        setPais({ valor: e.target.value, nombre: e.target.options[e.target.selectedIndex].innerHTML })
        //leo los cargos del cole seleccionado
        const promiseCargosPaisDisponibles = config.fetchCargosPaises(e.target.value, ErrorHandling)
        setCargosPais(await promiseCargosPaisDisponibles)
    }
    //funcion para refrescar con el id del pais desde otros componentes
    const refrescaPaisesDesdeOtros = async () => {
        //leo los cargos del cole seleccionado
        const promiseCargosPaisDisponibles = config.fetchCargosPaises(pais.valor, ErrorHandling)
        setCargosPais([])
        setCargosPais(await promiseCargosPaisDisponibles)

    }

    //DATOS funcion para refrescar datos desde fuera
    const refrescaDatosDesdeOtros = async () => {
        //obtengo cargos disponibles de la FET
        const promiseCargos = config.fetchCargos(ErrorHandling)
        setCargos([]);
        setCargos(await promiseCargos);
    }
    //CONTENEDOR DE PESTAÑAS DE, POR EJEMPLO, FET
    return (
        <Container>
            <Banner name={config.name} logo={config.logo} />
            {/* 1 fila que contiene la familia seleccionada*/}
            <Row>
                {/* 1 columna, en este caso única para contener las tablas con los formularios necesarios */}
                <Col>
                    {/* listado de pestañas obtenido de la variable config que define el contenido de las mismas. se recorre el arrai tabs y se monta*/}
                    <Tabs>
                        {config.tabs && config.tabs.map((item, idx) =>
                            <Tab eventKey={idx} title={item.name}>
                                {/*pongo el contenido de cada pestaña*/}
                                <TabContent
                                    key={item.name}
                                    fields={item.fields}
                                    cargos={cargos}
                                    disponibles={disponibles}
                                    post={(x, y) => {
                                        setRefresh(!refresh)
                                        return config.post(x, y);
                                    }}
                                    setRefresh={setRefresh}
                                    getExtern={config.fetchExternos}
                                    refresca={refrescaDatosDesdeOtros}
                                />
                            </Tab>
                        )}
                        {/* si la configuracion config (config.js) de esta familia tiene coles, recorro el array y monto la pestaña de colegios con su formulario*/}
                        {config.extra === 'coles' && <Tab title={config.coles[0].name} eventKey={4}>
                            <Form.Control className="mt-2" as="select" onChange={hePicadoCole} value={cole.valor} custom>
                                <option value="">--Seleccione un colegio-</option>
                                {colegios.length &&
                                    colegios.map((item) => {
                                        return (
                                            <option key={item.id} value={item.id}>
                                                {item.nombre + ' - ' + item.provincia}
                                            </option>
                                        );
                                    })}
                            </Form.Control>

                            {/*si selecciono un cole del formulario de coles anterior muestro la info del cole con sus cargos*/}
                            {cole.valor && <Tabs className="mt-4">
                                {config.coles && config.coles.map((item, idx) =>
                                    <Tab eventKey={idx} title={'Colegio seleccionado: ' + cole.nombre}>
                                        {/*monto contenido del tab del cole*/}
                                        <TabContent
                                            key={item.name}
                                            fields={item.fields}
                                            cargos={cargosCole}
                                            disponibles={disponiblesCole}
                                            post={(x, y) => {
                                                setRefreshCole(!refreshCole)
                                                return config.postCole(x, y, cole);
                                            }
                                            }
                                            setRefreshCole={setRefreshCole}
                                            getExtern={config.fetchExternos}
                                            colegioseleccionado={cole}
                                            refresca={refrescaColesDesdeOtros}
                                        />

                                    </Tab>
                                )}
                            </Tabs>}

                        </Tab>
                        }

                        {config.extra === 'paises' && <Tab title={config.paises[0].name} eventKey={4}>
                            <Form.Control className="mt-2" as="select" onChange={hePicadoPais} value={pais.valor} custom>
                                <option value="">--Seleccione un país-</option>
                                {paises.length &&
                                    paises.map((item) => {
                                        return (
                                            <option key={item.id} value={item.id}>
                                                {item.country + ' - ' + item.continent}
                                            </option>
                                        );
                                    })}
                            </Form.Control>


                            {/*si selecciono un pais del formulario de paises anterior muestro la info del pais con sus cargos*/}
                            {pais.valor && <Tabs className="mt-4">
                                {config.paises && config.paises.map((item, idx) =>
                                    <Tab eventKey={idx} title={'País seleccionado: ' + pais.nombre}>

                                        <TabContent
                                            key={item.name}
                                            fields={item.fields}
                                            cargos={cargosPais}
                                            disponibles={disponiblesPais}
                                            post={(x, y) => {
                                                setRefreshPais(!refreshPais)
                                                return config.postPais(x, y, pais);
                                            }
                                            }
                                            setRefreshPais={setRefreshPais}
                                            getExtern={config.fetchExternos}
                                            colegioseleccionado={pais}
                                            refresca={refrescaPaisesDesdeOtros}
                                        />

                                    </Tab>
                                )}
                            </Tabs>}

                        </Tab>
                        }
                        {/* listado de hermanas*/}
                        {config.familia === 'MTA' && <Tab title={"Misión Local Hermanas"} eventKey={config.tabs ? config.tabs.length+1 : 0}>
                            <ListaMisionLocalHermanas familia={config.familia} />
                        </Tab>
                        }
                        {/* listado de externos*/}
                        <Tab title={"Externos"} eventKey={config.tabs ? config.tabs.length+6 : 1}>
                            <ListaExternos fetchExternos={config.fetchExternos} urlAdd={config.urlAddExterno} familia={config.familia} />
                        </Tab>
                    </Tabs>
                </Col>

            </Row>
        </Container>
    )
};


export default Organizacion;